//Try to use alphabetic order
import { AppUpdateComponent } from "src/app/pages/app-update/app-update.component";
import { AppRestrictedComponent } from "src/app/pages/app-restricted/app-restricted.component";
import { DepositMainComponent } from "src/app/pages/cashier/deposit/deposit-main/deposit-main.component";
import { ForgotPasswordComponent } from "src/app/pages/forgot-password/forgot-password.component";
import { LoginComponent } from "src/app/pages/login/login.component";
import { PlayerProtectionComponent } from "src/app/pages/responsible-gaming/player-protection/player-protection.component";
import { SignupStepOneComponent } from "src/app/pages/signup-step-one/signup-step-one.component";
import { SignupStepTwoComponent } from "src/app/pages/signup-step-two/signup-step-two.component";
import { IdologyKbaComponent } from "src/app/pages/idology-kba/idology-kba.component";
import { UpdatePhoneNumberComponent } from "src/app/pages/update-phone-number/update-phone-number.component";
import { DepositCageComponent } from "src/app/pages/cashier/deposit/deposit-cage/deposit-cage.component";
import { SetDepositLimitsComponent } from "src/app/pages/limits/set-deposit-limits/set-deposit-limits.component";
import { DepositCreditcardComponent } from "src/app/pages/cashier/deposit/deposit-creditcard/deposit-creditcard.component";
import { DepositPlayplusComponent } from "src/app/pages/cashier/deposit/deposit-playplus/deposit-playplus.component";
import { DepositPaynearmeComponent } from "src/app/pages/cashier/deposit/deposit-paynearme/deposit-paynearme.component";
import { DepositPaypalComponent } from "src/app/pages/cashier/deposit/deposit-paypal/deposit-paypal.component";
import { DepositVipComponent } from "src/app/pages/cashier/deposit/deposit-vip/deposit-vip.component";
import { DepositPaywithmybankComponent } from "src/app/pages/cashier/deposit/deposit-paywithmybank/deposit-paywithmybank.component";
import { DepositSuccessFailureComponent } from "src/app/pages/cashier/deposit/deposit-success-failure/deposit-success-failure.component";
import { AccountInformationComponent } from "src/app/pages/information-and-security/account-information/account-information.component";
import { PersonalInformationComponent } from "src/app/pages/information-and-security/personal-information/personal-information.component";
import { UploadDocumentComponent } from "src/app/pages/information-and-security/upload-document/upload-document.component";
import { ChangePasswordComponent } from "src/app/pages/information-and-security/change-password/change-password.component";
import { SecurityQuestionComponent } from "src/app/pages/information-and-security/security-question/security-question.component";
import { ResendPinComponent } from "src/app/pages/information-and-security/resend-pin/resend-pin.component";
import { SetTimeLimitsComponent } from "src/app/pages/limits/set-time-limits/set-time-limits.component";
import { AccountBalanceComponent } from "src/app/pages/account-balance/account-balance.component";
import { SetLossLimitsComponent } from "src/app/pages/limits/set-loss-limits/set-loss-limits.component";
import { RafOverviewComponent } from "src/app/pages/refer-a-friend/raf-overview/raf-overview.component";
import { RafInviteEmailComponent } from "src/app/pages/refer-a-friend/raf-invite-email/raf-invite-email.component";
import { ActiveBonusesComponent } from "src/app/pages/rewards/bonuses/active-bonuses/active-bonuses.component";
import { BonusOffersComponent } from "src/app/pages/rewards/bonuses/bonus-offers/bonus-offers.component";
import { PastBonusesComponent } from "src/app/pages/rewards/bonuses/past-bonuses/past-bonuses.component";
import { SetSingleBetLimitsComponent } from "src/app/pages/limits/set-single-bet-limits/set-single-bet-limits.component";
import { WithdrawalPaypalComponent } from "src/app/pages/cashier/withdraw/withdrawal-paypal/withdrawal-paypal.component";
import { WithdrawalVipComponent } from "src/app/pages/cashier/withdraw/withdrawal-vip/withdrawal-vip.component";
import { WithdrawalPrepaidComponent } from "src/app/pages/cashier/withdraw/withdrawal-prepaid/withdrawal-prepaid.component";
import { WithdrawalCageComponent } from "src/app/pages/cashier/withdraw/withdrawal-cage/withdrawal-cage.component";
import { WithdrawalReverseComponent } from "src/app/pages/cashier/withdraw/withdrawal-reverse/withdrawal-reverse.component";
import { TransactionHistoryComponent } from "src/app/pages/cashier/transaction-history/transaction-history.component";
import { LimitsHistoryComponent } from "src/app/pages/limits/limits-history/limits-history.component";
import { CoolOffComponent } from "src/app/pages/cool-off/cool-off.component";
import { BonusDetailsComponent } from "src/app/pages/rewards/bonuses/bonus-details/bonus-details.component";
import { StrongAuthenticationComponent } from "src/app/pages/information-and-security/strong-authentication/strong-authentication.component";
import { AccountSummaryComponent } from "src/app/pages/account-summary/account-summary.component";

import { GameSettingsComponent } from "src/app/pages/information-and-security/game-settings/game-settings.component";
import { WithdrawalReverseConfirmComponent } from "src/app/pages/cashier/withdraw/withdrawal-reverse-confirm/withdrawal-reverse-confirm.component";
import { RedeemBonusCodeComponent } from "src/app/pages/rewards/bonuses/redeem-bonus-code/redeem-bonus-code.component";
import { RiskFreeBetRiskComponent } from "src/app/pages/rewards/bonuses/risk-free-bet-risk/risk-free-bet-risk.component";
import { TotalDepositsComponent } from "src/app/pages/cashier/overview/total-deposits/total-deposits.component";
import { RejectedWithdrawalsComponent } from "src/app/pages/cashier/overview/rejected-withdrawals/rejected-withdrawals.component";
import { PendingWithdrawalsComponent } from "src/app/pages/cashier/overview/pending-withdrawals/pending-withdrawals.component";
import { TotalWithdrawalsComponent } from "src/app/pages/cashier/overview/total-withdrawals/total-withdrawals.component";
import { WithdrawalMailComponent } from "src/app/pages/cashier/withdraw/withdrawal-mail/withdrawal-mail.component";
import { TaxReportsComponent } from "src/app/pages/tax-reports/tax-reports.component";
import { WinLossComponent } from "src/app/pages/cashier/win-loss/win-loss.component";
import { MyFreeSpinComponent } from "src/app/pages/rewards/bonuses/my-free-spin/my-free-spin.component";
import { SelfExcludeComponent } from "src/app/pages/self-exclude/self-exclude.component";
import { DailySlotComponent } from "src/app/pages/daily-slot/daily-slot.component";
import { GameTransactionsComponent } from "src/app/pages/game-transactions/game-transactions.component";
import { DepositThresholdComponent } from "src/app/pages/cashier/deposit/deposit-threshold/deposit-threshold.component";
import { WithdrawalPayWithMyBankComponent } from "src/app/pages/cashier/withdraw/withdrawal-pay-with-my-bank/withdrawal-pay-with-my-bank.component";
import { GameHistoryComponent } from "src/app/pages/game-history/game-history.component";
import { DeleteAccountComponent } from "src/app/pages/delete-account/delete-account.component";
import { SmsLoginComponent } from "src/app/pages/sms-login/sms-login.component";
import { InvalidKycComponent } from "src/app/pages/invalid-kyc/invalid-kyc.component";
import { CamsComponent } from "src/app/pages/cams/cams.component";
import { IdNowComponent } from "src/app/pages/id-now/id-now.component";
import { SignupResultComponent } from "src/app/pages/signup-result/signup-result.component";
import { ManageNotificationsComponent } from "src/app/pages/information-and-security/manage-notifications/manage-notifications.component";
import { SpendLimitComponent } from "src/app/pages/limits/spend-limit/spend-limit.component";
import { LimitConfirmationComponent } from "src/app/pages/limits/limit-confirmation/limit-confirmation.component";
import { MyTransactionMethodsComponent } from "src/app/pages/my-transaction-methods/my-transaction-methods.component";

import { TabLandingPage } from "src/app/tabs/tab-landing/tab-landing.page";
import { DepositPayWithCashComponent } from "src/app/pages/cashier/deposit/deposit-pay-with-cash/deposit-pay-with-cash.component";
import { UpdateTocComponent } from "src/app/pages/update-toc/update-toc.component";
import { UpdatePrivacyPolicyComponent } from "src/app/pages/update-privacy-policy/update-privacy-policy.component";
import { UpdateHouseRulesComponent } from "src/app/pages/update-house-rules/update-house-rules.component";
import { ResetPasswordComponent } from "src/app/pages/reset-password/reset-password.component";
import { DepositPlayplusActionComponent } from "src/app/pages/cashier/deposit/deposit-playplus/deposit-playplus-action.component";
import { CoolingOffComponent } from "src/app/pages/cooling-off/cooling-off.component"; import { ResetPasswordVerifyFirstStepComponent } from "src/app/pages/reset-password/reset-password-verify-first-step/reset-password-verify-first-step.component";
import { ResetPasswordVerifySecondStepComponent } from "src/app/pages/reset-password/reset-password-verify-second-step/reset-password-verify-second-step.component";
import { ResetPasswordVerifyThirdStepComponent } from "src/app/pages/reset-password/reset-password-verify-third-step/reset-password-verify-third-step.component";
import { ExternalLinkContentComponent } from "src/app/pages/external-link-content/external-link-content.component";
import { PasswordResetComponent } from "src/app/pages/password-reset/password-reset.component";
import { PlayerMigrationComponent } from "src/app/pages/player-migration/player-migration.component";
import { PlayerMigrationActionComponent } from "src/app/pages/player-migration/player-migration-action.component";
import { DepositWireComponent } from "src/app/pages/cashier/deposit/deposit-wire/deposit-wire.component";
import { BoydRewardsConnectComponent } from "src/app/pages/boyd-rewards/boyd-rewards-connect/boyd-rewards-connect.component";
import { BoydMyBalanceComponent } from "src/app/pages/boyd-rewards/boyd-my-balance/boyd-my-balance.component";
import { EnrollBoydRewardsComponent } from "src/app/pages/boyd-rewards/enroll-boyd-rewards/enroll-boyd-rewards.component";
import { BoydRedeemRewardsComponent } from "src/app/pages/boyd-rewards/boyd-redeem-rewards/boyd-redeem-rewards.component";
import { ContentPlaceholderComponent } from "src/app/pages/content-placeholder/content-placeholder.component";
import { DepositInstaDebitActionPage } from "src/app/pages/cashier/deposit/deposit-instadebit-action/deposit-instadebit-action";
import { DepositInstaDebitPage } from "src/app/pages/cashier/deposit/deposit-instadebit/deposit-instadebit";
import { DepositIDebitPage } from "src/app/pages/cashier/deposit/deposit-idebit/deposit-idebit";
import { DepositIdebitActionPage } from "src/app/pages/cashier/deposit/deposit-idebit-action/deposit-idebit-action";
import { DepositECheckPage } from "src/app/pages/cashier/deposit/deposit-e-check/deposit-e-check";
import { DepositECheckAddPage } from "src/app/pages/cashier/deposit/deposit-e-check-add/deposit-e-check-add";
import { DepositECheckBasePage } from "src/app/pages/cashier/deposit/deposit-e-check-base/deposit-e-check-base";
import { DepositNeosurfComponent } from "src/app/pages/cashier/deposit/deposit-neosurf/deposit-neosurf.component";
import { DepositGigadetInteracPage } from "src/app/pages/cashier/deposit/deposit-interac/deposit-interac";
import { DepositInteracActionPage } from "src/app/pages/cashier/deposit/deposit-interac-action/deposit-interac-action";
import { WithdrawalECheckAddPage } from "src/app/pages/cashier/withdraw/withdrawal-echeck-add/withdrawal-echeck-add";
import { WithdrawalECheckPage } from "src/app/pages/cashier/withdraw/withdrawal-echeck/withdrawal-echeck";
import { WithdrawalIDebitPage } from "src/app/pages/cashier/withdraw/withdrawal-idebit/withdrawal-idebit";
import { WithdrawalInstaDebitPage } from "src/app/pages/cashier/withdraw/withdrawal-instadebit/withdrawal-instadebit";
import { WithdrawalInteracPage } from "src/app/pages/cashier/withdraw/withdrawal-interac/withdrawal-interac";
import { WithdrawalInteracAddPage } from "src/app/pages/cashier/withdraw/withdrawal-interac-add/withdrawal-interac-add";
import { PinLoginComponent } from "src/app/pages/login/pin-login/pin-login";
import { DepositNeosurfActionComponent } from "src/app/pages/cashier/deposit/deposit-neosurf/deposit-neosurf-action.component";
import { PiggyBankComponent } from "src/app/pages/piggy-bank/piggy-bank.component";
import { LeaderboardComponent } from "src/app/pages/leaderboard/leaderboard.component";
import { ShopPageComponent } from "src/app/pages/shop-page/shop-page.component";
import { SettingsComponent } from "src/app/pages/settings/settings.component";
import { AvatarComponent } from "src/app/pages/avatar/avatar.component";
import { BonusContentPage } from "src/app/popovers/bonus-content/bonus-content.page";
import { CreditCardComponent } from "../shop/credit-card/credit-card.component";
import { PurchaseSuccessFailureComponent } from "../shop/purchase-success-failure/purchase-success-failure.component";
import { RocketBonusGameLaunchComponent } from "src/app/components/rocket-bonus-game-launch/rocket-bonus-game-launch.component";
import { LaunchCheckComponent } from "src/app/components/launch-check/launch-check.component";
import { GuestPlayerTocComponent } from "src/app/components/guest-player-toc/guest-player-toc.component";
import { BoydRewardsOptionsComponent } from "src/app/components/boyd-rewards-options/boyd-rewards-options.component";
import { AccountCreatedConfirmationComponent } from "src/app/components/account-created-confirmation/account-created-confirmation.component";
import { ApplyBoydRewardsStepOneComponent } from "src/app/components/apply-boyd-rewards-step-one/apply-boyd-rewards-step-one.component";
import { ApplyBoydRewardsStepTwoComponent } from "src/app/components/apply-boyd-rewards-step-two/apply-boyd-rewards-step-two.component";
import { AllPurposeDrawerComponent } from "../all-purpose-drawer/all-purpose-drawer.component";
import { AskCustomerRotateComponent } from "../ask-customer-rotate/ask-customer-rotate.component";
import { GameDetailPageComponent } from "src/app/pages/game-detail-page/game-detail-page.component";
import { PiggyBankTutorialComponent } from "src/app/pages/piggy-bank/piggy-bank-tutorial/piggy-bank-tutorial.component";
import { PiggyPurchaseSuccessFailureComponent } from "src/app/pages/piggy-bank/piggy-purchase-success-failure/piggy-purchase-success-failure.component";
import { ContestComponent } from "src/app/pages/contest/contest.component";

import { LeaderboardTutorialComponent } from "src/app/pages/leaderboard/leaderboard-tutorial/leaderboard-tutorial.component";
import { LeaderboardCongratsPopupComponent } from "src/app/pages/leaderboard-congrats-popup/leaderboard-congrats-popup.component";
import { LeaderboardEndCongratsPopupComponent } from "src/app/pages/leaderboard/leaderboard-end-congrats/leaderboard-end-congrats.component";
import { MigrationSuccessComponent } from "../migration-success/migration-success.component";
import { LocationSettingsComponent } from '../location-settings/location-settings.component'
import { BoydRewardsLaunchComponent } from "../boyd-rewards-launch/boyd-rewards-launch.component";
import { ResetBoydPasswordComponent } from "src/app/pages/reset-password/reset-boyd-password/reset-boyd-password.component";
import { DownloadAppsComponent } from "src/app/pages/download-apps/download-apps.component";
import { SiteMenuComponent } from "src/app/pages/site-menu/site-menu.component";
import { BoydRewardsCardOrOnline } from "../boyd-rewards-card-or-online/boyd-rewards-card-or-online.component";
import { SocialPlayerTocComponent } from "../social-player-toc/social-player-toc.component";
import { SignupRedirectComponent } from "src/app/pages/signup-redirect/signup-redirect.component";
import { SignupOptionsStepOneComponent } from "src/app/pages/signup-options-step-one/signup-options-step-one.component";
import { SignupOptionsStepTwoComponent } from "src/app/pages/signup-options-step-two/signup-options-step-two.component";
import { AlertNotificationComponent } from "src/app/pages/alert-notification/alert-notification.component";
//Factory for Modals
// DepositCageModule,
// DepositCreditcardModule,
// DepositMainModule,
// DepositPaypalModule,
// DepositPrepaidModule,
// DepositVipModule,

//when adding new componenet to classFactory object please add to routeFactory object as well with URL friendly name
const classFactory: Object = {
  AccountBalanceComponent: AccountBalanceComponent,
  AccountInformationComponent: AccountInformationComponent,
  ActiveBonusesComponent: ActiveBonusesComponent,
  AskCustomerRotateComponent: AskCustomerRotateComponent,
  BoydRewardsConnectComponent: BoydRewardsConnectComponent,
  BoydMyBalanceComponent: BoydMyBalanceComponent,
  BonusDetailsComponent: BonusDetailsComponent,
  AppUpdateComponent: AppUpdateComponent,
  AppRestrictedComponent: AppRestrictedComponent,
  BonusOffersComponent: BonusOffersComponent,
  BoydRedeemRewardsComponent: BoydRedeemRewardsComponent,
  ContentPlaceholderComponent: ContentPlaceholderComponent,
  DailySlotComponent: DailySlotComponent,
  DepositCageComponent: DepositCageComponent,
  DepositCreditcardComponent: DepositCreditcardComponent,
  DepositMainComponent: DepositMainComponent,
  DepositPaynearmeComponent: DepositPaynearmeComponent,
  DepositPaypalComponent: DepositPaypalComponent,
  DepositPlayplusComponent: DepositPlayplusComponent,
  DepositPlayplusActionComponent: DepositPlayplusActionComponent,
  DepositPaywithmybankComponent: DepositPaywithmybankComponent,
  DepositGigadetInteracPage: DepositGigadetInteracPage,
  DepositInteracActionPage: DepositInteracActionPage,
  DepositInstaDebitPage: DepositInstaDebitPage,
  DepositInstaDebitActionPage: DepositInstaDebitActionPage,
  DepositECheckPage: DepositECheckPage,
  DepositECheckAddPage: DepositECheckAddPage,
  DepositECheckBasePage: DepositECheckBasePage,
  DepositIdebitActionPage: DepositIdebitActionPage,
  DepositIDebitPage: DepositIDebitPage,
  DepositVipComponent: DepositVipComponent,
  DepositSuccessFailureComponent: DepositSuccessFailureComponent,
  DepositNeosurfComponent: DepositNeosurfComponent,
  DepositNeosurfActionComponent: DepositNeosurfActionComponent,
  DepositThresholdComponent: DepositThresholdComponent,
  DepositWireComponent: DepositWireComponent,
  EnrollBoydRewardsComponent: EnrollBoydRewardsComponent,
  ForgotPasswordComponent: ForgotPasswordComponent,
  LoginComponent: LoginComponent,
  MyFreeSpinComponent: MyFreeSpinComponent,
  PlayerProtectionComponent: PlayerProtectionComponent,
  PastBonusesComponent: PastBonusesComponent,
  RedeemBonusCodeComponent: RedeemBonusCodeComponent,
  RiskFreeBetRiskComponent: RiskFreeBetRiskComponent,
  SignupStepOneComponent: SignupStepOneComponent,
  SignupStepTwoComponent: SignupStepTwoComponent,
  PersonalInformationComponent: PersonalInformationComponent,
  UploadDocumentComponent: UploadDocumentComponent,
  ChangePasswordComponent: ChangePasswordComponent,
  SetDepositLimitsComponent: SetDepositLimitsComponent,
  ResendPinComponent: ResendPinComponent,
  LocationSettingsComponent: LocationSettingsComponent,
  SecurityQuestionComponent: SecurityQuestionComponent,
  PendingWithdrawalsComponent: PendingWithdrawalsComponent,
  RafOverviewComponent: RafOverviewComponent,
  RafInviteEmailComponent: RafInviteEmailComponent,
  RejectedWithdrawalsComponent: RejectedWithdrawalsComponent,
  SetTimeLimitsComponent: SetTimeLimitsComponent,
  SetLossLimitsComponent: SetLossLimitsComponent,
  SetSingleBetLimitsComponent: SetSingleBetLimitsComponent,
  LimitConfirmationComponent: LimitConfirmationComponent,
  TaxReportsComponent: TaxReportsComponent,
  TabLandingPage: TabLandingPage,
  TotalDepositsComponent: TotalDepositsComponent,
  TotalWithdrawalsComponent: TotalWithdrawalsComponent,
  WithdrawalPaypalComponent: WithdrawalPaypalComponent,
  WithdrawalVipComponent: WithdrawalVipComponent,
  WithdrawalPrepaidComponent: WithdrawalPrepaidComponent,
  WithdrawalCageComponent: WithdrawalCageComponent,
  WithdrawalReverseComponent: WithdrawalReverseComponent,
  WithdrawalReverseConfirmComponent: WithdrawalReverseConfirmComponent,
  WithdrawalPayWithMyBankComponent: WithdrawalPayWithMyBankComponent,
  TransactionHistoryComponent: TransactionHistoryComponent,
  LimitsHistoryComponent: LimitsHistoryComponent,
  StrongAuthenticationComponent: StrongAuthenticationComponent,
  GameSettingsComponent: GameSettingsComponent,
  WithdrawalMailComponent: WithdrawalMailComponent,
  WinLossComponent: WinLossComponent,
  CoolOffComponent: CoolOffComponent,
  AccountSummaryComponent: AccountSummaryComponent,
  SelfExcludeComponent: SelfExcludeComponent,
  GameTransactionsComponent: GameTransactionsComponent,
  IdologyKbaComponent: IdologyKbaComponent,
  InvalidKycComponent: InvalidKycComponent,
  CamsComponent: CamsComponent,
  IdNowComponent: IdNowComponent,
  SignupResultComponent: SignupResultComponent,
  UpdatePhoneNumberComponent: UpdatePhoneNumberComponent,
  GameHistoryComponent: GameHistoryComponent,
  DeleteAccountComponent: DeleteAccountComponent,
  SmsLoginComponent: SmsLoginComponent,
  ManageNotificationsComponent: ManageNotificationsComponent,
  SpendLimitComponent: SpendLimitComponent,
  MyTransactionMethodsComponent: MyTransactionMethodsComponent,
  DepositPayWithCashComponent: DepositPayWithCashComponent,
  UpdateTocComponent: UpdateTocComponent,
  UpdatePrivacyPolicyComponent: UpdatePrivacyPolicyComponent,
  PinLoginComponent: PinLoginComponent,
  UpdateHouseRulesComponent: UpdateHouseRulesComponent,
  ResetPasswordComponent: ResetPasswordComponent,
  BoydRewardsLaunchComponent: BoydRewardsLaunchComponent,
  CoolingOffComponent: CoolingOffComponent,
  ResetPasswordVerifyFirstStepComponent: ResetPasswordVerifyFirstStepComponent,
  ResetPasswordVerifySecondStepComponent: ResetPasswordVerifySecondStepComponent,
  ResetPasswordVerifyThirdStepComponent: ResetPasswordVerifyThirdStepComponent,
  ExternalLinkContentComponent: ExternalLinkContentComponent,
  PasswordResetComponent: PasswordResetComponent,
  PlayerMigrationComponent: PlayerMigrationComponent,
  PlayerMigrationActionComponent: PlayerMigrationActionComponent,
  WithdrawalECheckAddPage: WithdrawalECheckAddPage,
  WithdrawalECheckPage: WithdrawalECheckPage,
  WithdrawalIDebitPage: WithdrawalIDebitPage,
  WithdrawalInstaDebitPage: WithdrawalInstaDebitPage,
  WithdrawalInteracPage: WithdrawalInteracPage,
  WithdrawalInteracAddPage: WithdrawalInteracAddPage,
  PiggyBankComponent: PiggyBankComponent,
  PiggyBankTutorialComponent: PiggyBankTutorialComponent,
  LeaderboardTutorialComponent: LeaderboardTutorialComponent,
  AllPurposeDrawerComponent: AllPurposeDrawerComponent,
  LeaderboardCongratsPopupComponent: LeaderboardCongratsPopupComponent,
  LeaderboardEndCongratsPopupComponent: LeaderboardEndCongratsPopupComponent,
  LeaderboardComponent: LeaderboardComponent,
  ShopPageComponent: ShopPageComponent,
  SettingsComponent: SettingsComponent,
  AvatarComponent: AvatarComponent,
  BonusContentPage: BonusContentPage,
  CreditCardComponent: CreditCardComponent,
  PurchaseSuccessFailureComponent: PurchaseSuccessFailureComponent,
  RocketBonusGameLaunchComponent: RocketBonusGameLaunchComponent,
  LaunchCheckComponent: LaunchCheckComponent,
  MigrationSuccessComponent: MigrationSuccessComponent,
  AccountCreatedConfirmationComponent: AccountCreatedConfirmationComponent,
  ApplyBoydRewardsStepOneComponent: ApplyBoydRewardsStepOneComponent,
  ApplyBoydRewardsStepTwoComponent: ApplyBoydRewardsStepTwoComponent,
  GuestPlayerTocComponent: GuestPlayerTocComponent,
  BoydRewardsOptionsComponent: BoydRewardsOptionsComponent,
  GameDetailPageComponent: GameDetailPageComponent,
  PiggyPurchaseSuccessFailureComponent: PiggyPurchaseSuccessFailureComponent,
  ContestComponent: ContestComponent,
  SignupOptionsStepOneComponent: SignupOptionsStepOneComponent,
  SignupOptionsStepTwoComponent: SignupOptionsStepTwoComponent,
  ResetBoydPasswordComponent: ResetBoydPasswordComponent,
  DownloadAppsComponent: DownloadAppsComponent,
  SiteMenuComponent: SiteMenuComponent,
  BoydRewardsCardOrOnline: BoydRewardsCardOrOnline,
  SocialPlayerTocComponent: SocialPlayerTocComponent,
  SignupRedirectComponent: SignupRedirectComponent,
  AlertNotificationComponent: AlertNotificationComponent
};

export const stringToClass = (className) => {
  if (className in classFactory) {
    return classFactory[className];
  }
  return console.log("No page class match for " + className);
};

//URL friendly name of component for pageView event.
const routeFactory: Object = {
  AccountBalanceComponent: 'account-balance',
  AccountInformationComponent: 'account-information',
  ActiveBonusesComponent: 'active-bonuses',
  AskCustomerRotateComponent: 'ask-customer-rotate',
  BoydRewardsConnectComponent: 'boyd-rewards-connect',
  BoydMyBalanceComponent: 'boyd-my-balance',
  BonusDetailsComponent: 'bonus-details',
  AppUpdateComponent: 'app-update',
  AppRestrictedComponent: 'app-restricted',
  BonusOffersComponent: 'bonus-offers',
  ContentPlaceholder: 'content-placeholder',
  DailySlotComponent: 'daily-slot',
  DepositCageComponent: 'deposit-cage',
  DepositCreditcardComponent: 'deposit-creditcard',
  DepositMainComponent: 'deposit-main',
  DepositPaynearmeComponent: 'deposit-paynearme',
  DepositPaypalComponent: 'deposit-paypal',
  DepositPlayplusComponent: 'deposit-playplus',
  DepositPlayplusActionComponent: 'deposit-playplus-action',
  DepositPaywithmybankComponent: 'deposit-paywithmybank',
  DepositVipComponent: 'deposit-vip',
  DepositSuccessFailureComponent: 'deposit-successFailure',
  DepositThresholdComponent: 'deposit-threshold',
  DepositWireComponent: 'deposit-wire',
  ForgotPasswordComponent: 'forgot-password',
  LoginComponent: 'login',
  MyFreeSpinComponent: 'my-free-spin',
  PlayerProtectionComponent: 'player-protection',
  PastBonusesComponent: 'past-bonuses',
  RedeemBonusCodeComponent: 'redeem-bonus-code',
  RiskFreeBetRiskComponent: 'risk-free-bet-risk',
  SignupStepOneComponent: 'signup-step-one',
  SignupStepTwoComponent: 'signup-step-two',
  SignupOptionsStepOneComponent: 'signup-options',
  SignupOptionsStepTwoComponent: 'signup-options-step-two',
  PersonalInformationComponent: 'personal-information',
  PinLoginComponent: 'pin-login',
  UploadDocumentComponent: 'upload-document',
  ChangePasswordComponent: 'change-password',
  SetDepositLimitsComponent: 'set-deposit-limits',
  ResendPinComponent: 'resend-pin',
  SecurityQuestionComponent: 'security-question',
  PendingWithdrawalsComponent: 'pending-withdrawals',
  RafOverviewComponent: 'raf-overview',
  RafInviteEmailComponent: 'raf-invite-email',
  RejectedWithdrawalsComponent: 'rejected-withdrawals',
  SetTimeLimitsComponent: 'set-time-limits',
  SetLossLimitsComponent: 'set-loss-limits',
  SetSingleBetLimitsComponent: 'set-single-bet-limits',
  TaxReportsComponent: 'tax-reports',
  TabLandingPage: 'landing-page',
  TotalDepositsComponent: 'total-deposits',
  TotalWithdrawalsComponent: 'total-withdrawals',
  WithdrawalPaypalComponent: 'withdrawal-paypal',
  WithdrawalVipComponent: 'withdrawal-vip',
  WithdrawalPrepaidComponent: 'withdrawal-prepaid',
  WithdrawalCageComponent: 'withdrawal-cage',
  WithdrawalReverseComponent: 'withdrawal-reverse',
  WithdrawalReverseConfirmComponent: 'withdrawal-reverse-confirm',
  WithdrawalPayWithMyBankComponent: 'withdrawal-payWithMyBank',
  TransactionHistoryComponent: 'transaction-history',
  LimitsHistoryComponent: 'limits-history',
  StrongAuthenticationComponent: 'strong-authentication',
  GameSettingsComponent: 'game-settings',
  WithdrawalMailComponent: 'withdrawal-mail',
  WinLossComponent: 'win-loss',
  CoolOffComponent: 'cool-off',
  AccountSummaryComponent: 'account-summary',
  SelfExcludeComponent: 'self-exclude',
  GameTransactionsComponent: 'game-transactions',
  IdologyKbaComponent: 'idology-kba',
  InvalidKycComponent: 'invalid-kyc',
  CamsComponent: 'cams',
  IdNowComponent: 'id-now',
  SignupResultComponent: 'signup-result',
  UpdatePhoneNumberComponent: 'update-phonenumber',
  GameHistoryComponent: 'game-history',
  DeleteAccountComponent: 'delete-account',
  SmsLoginComponent: 'sms-login',
  ManageNotificationsComponent: 'manage-notifications',
  SpendLimitComponent: 'spend-limit',
  MyTransactionMethodsComponent: 'my-transaction-methods',
  DepositPayWithCashComponent: 'deposit-pay-with-cash',
  UpdateTocComponent: 'update-toc',
  UpdatePrivacyPolicyComponent: 'update-privacy-policy',
  UpdateHouseRulesComponent: 'update-house-rules',
  ResetPasswordComponent: 'reset-password',
  CoolingOffComponent: 'cooling-off',
  ResetPasswordVerifyFirstStepComponent: 'reset-password-verify-first-step',
  ResetPasswordVerifySecondStepComponent: 'reset-password-verify-second-step',
  ResetPasswordVerifyThirdStepComponent: 'reset-password-verify-third-step',
  ExternalLinkContentComponent: 'external-link-content',
  PasswordResetComponent: 'password-reset',
  PlayerMigrationActionComponent: 'player-migration-action',
  LimitConfirmationComponent: 'limit-adjustment-confirmation',
  BoydRedeemRewardsComponent: 'boyd-redeem-rewards',
  BonusContentPage: "BonusContentPage",
  RocketBonusGameLaunchComponent: 'rocket-bonus-game-launch',
  LaunchCheckComponent: 'launch-check',
  GuestPlayerTocComponent: 'guest-player-toc',
  BoydRewardsOptionsComponent: 'boyd-rewards-options',
  AccountCreatedConfirmationComponent: 'account-created-confirmation',
  ApplyBoydRewardsStepOneComponent: 'apply-boyd-rewards-step-one',
  ApplyBoydRewardsStepTwoComponent: 'apply-boyd-rewards-step-two',
  MigrationSuccessComponent: 'migration-success',
  LocationSettingsComponent: 'location-settings',
  BoydRewardsLaunchComponent: 'boyd-rewards-launch',
  AllPurposeDrawerComponent: 'app-all-purpose-drawer',
  BoydRewardsCardOrOnline: 'app-boyd-rewards-card-or-online',
  SiteMenuComponent: 'site-menu',
  SocialPlayerTocComponent: 'social-player-toc',
  SignupRedirectComponent: 'signup-redirect',
  AlertNotificationComponent: 'alert-notification'
};

export const checkRoutesName = (routeName) => {
  if (routeName in classFactory) {
    return routeFactory[routeName];
  }
  return console.log("No page class match for " + routeName);
};

//Empty Functions for Launcher path since we're only doing router for Casino and igorning all other paths for social.
export const checkRedirectLoggedInRoutesName = (routeName) => {
  return console.log("LoggedINRoute " + routeName);
};

export const checkRedirectLoggedOutRoutesName = (routeName) => {
  return console.log("LoggedOutRoute " + routeName);
};
